// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar-nav {\n  margin-right: 100px;\n}\nnav {\n  box-shadow: 0 8px 6px -6px #999;\n}\n.nav-link {\n  color: #b83027;\n}\n.navbar-toggler {\n  border-color: #b83027;\n}\n", ""]);
// Exports
module.exports = exports;
